// extracted by mini-css-extract-plugin
export default {"mainDiv":"Global_mainDiv__J11IL","mainInner":"Global_mainInner__bqiVR","heading":"Global_heading__ay3Dq","description":"Global_description__uD2ZU","footer":"Global_footer__aE7IQ"};